import {lazy} from 'react';
import {type RouteObject} from 'react-router-dom';

import {ProtectedRoute} from './ProtectedRoute';
import {
  managerPortalRoles,
  ASSESSORS_READ,
  CERTIFICATE_READ,
  FACILITATORS_READ,
  LEARNERS_READ,
  LEARNER_ENROLLMENTS_READ,
  MODERATORS_READ,
  OPTIX_ACADEMY_MANAGER_READ,
  // Temporarily unused while these pages are hidden
  // QUALIFICATIONS_READ,
  // SKILLS_PROGRAMS_READ,
  // TRAINING_COURSE_READ,
  // TRAINME_COURSES_READ,
  USER_PROFILE_SUMMARY_READ,
  USER_READ,
} from '../modules/common/constants/roles';
import {routes} from '../modules/common/constants/routes';
import {
  type Breadcrumb,
  breadcrumbLoaderFunction,
} from '../modules/common/stores/breadcrumbStore';
const ManagerPortalOverview = lazy(
  async () =>
    await import('../modules/managerPortal/pages/ManagerPortalOverview'),
);
// Temporarily hidden — re-enable when these pages are ready
// const ManagerPortalCourses = lazy(
//   async () => await import('../modules/managerPortal/pages/Courses'),
// );
// const ManagerPortalViewCourse = lazy(
//   async () => await import('../modules/managerPortal/pages/ViewCourse'),
// );
// const ManagerPortalSkillsProgrammes = lazy(
//   async () => await import('../modules/managerPortal/pages/SkillsProgrammes'),
// );
// const ManagerPortalQualifications = lazy(
//   async () => await import('../modules/managerPortal/pages/Qualifications'),
// );
const ManagerPortalCertificates = lazy(
  async () => await import('../modules/managerPortal/pages/Certificates'),
);
const ManagerPortalScheduler = lazy(
  async () => await import('../modules/managerPortal/pages/Scheduler'),
);
const ManagerPortalEnrollmentManagement = lazy(
  async () => await import('../modules/adminPortal/pages/EnrollmentManagement'),
);
const ManagerPortalUsers = lazy(
  async () => await import('../modules/adminPortal/pages/UserManagement'),
);
// const ManagerPortalCohortManagement = lazy(
//   async () => await import('../modules/managerPortal/pages/CohortManagement'),
// );
// const ManagerPortalCohortDetail = lazy(
//   async () => await import('../modules/managerPortal/pages/CohortDetail'),
// );
const ManagerPortalUserDetail = lazy(
  async () => await import('../modules/managerPortal/pages/UserDetail'),
);
// const ManagerPortalCourseModules = lazy(
//   async () => await import('../modules/managerPortal/pages/CourseModules'),
// );
// const ManagerPortalModuleManagement = lazy(
//   async () => await import('../modules/managerPortal/pages/ModuleManagement'),
// );
const ManagerPortalBroadcastAnnouncement = lazy(
  async () =>
    await import('../modules/managerPortal/pages/BroadcastAnnouncement'),
);

const baseManagerPortalBreadcrumbs: Breadcrumb[] = [
  {label: 'Manager Portal', path: routes.managerPortal.get()},
];

export const managerPortalChildren: RouteObject[] = [
  {
    path: '',
    element: (
      <ProtectedRoute roles={managerPortalRoles}>
        <ManagerPortalOverview />
      </ProtectedRoute>
    ),
    loader: breadcrumbLoaderFunction([{label: 'Manager Portal'}]),
  },
  {
    path: routes.managerPortal.overview,
    element: (
      <ProtectedRoute roles={managerPortalRoles}>
        <ManagerPortalOverview />
      </ProtectedRoute>
    ),
    loader: breadcrumbLoaderFunction([
      ...baseManagerPortalBreadcrumbs,
      {label: 'Overview'},
    ]),
  },
  // Temporarily hidden — re-enable when these pages are ready
  // {
  //   path: routes.managerPortal.courses,
  //   element: (
  //     <ProtectedRoute
  //       roles={[OPTIX_ACADEMY_MANAGER_READ, TRAINING_COURSE_READ]}
  //     >
  //       <ManagerPortalCourses />
  //     </ProtectedRoute>
  //   ),
  //   loader: breadcrumbLoaderFunction([
  //     ...baseManagerPortalBreadcrumbs,
  //     {label: 'Courses'},
  //   ]),
  // },
  // {
  //   path: routes.managerPortal.viewCourse,
  //   element: (
  //     <ProtectedRoute
  //       roles={[OPTIX_ACADEMY_MANAGER_READ, TRAINING_COURSE_READ]}
  //     >
  //       <ManagerPortalViewCourse />
  //     </ProtectedRoute>
  //   ),
  //   loader: breadcrumbLoaderFunction([
  //     ...baseManagerPortalBreadcrumbs,
  //     {label: 'View Course'},
  //   ]),
  // },
  // {
  //   path: routes.managerPortal.skillsProgrammes,
  //   element: (
  //     <ProtectedRoute
  //       roles={[OPTIX_ACADEMY_MANAGER_READ, SKILLS_PROGRAMS_READ]}
  //     >
  //       <ManagerPortalSkillsProgrammes />
  //     </ProtectedRoute>
  //   ),
  //   loader: breadcrumbLoaderFunction([
  //     ...baseManagerPortalBreadcrumbs,
  //     {label: 'Skills Programmes'},
  //   ]),
  // },
  // {
  //   path: routes.managerPortal.qualifications,
  //   element: (
  //     <ProtectedRoute roles={[OPTIX_ACADEMY_MANAGER_READ, QUALIFICATIONS_READ]}>
  //       <ManagerPortalQualifications />
  //     </ProtectedRoute>
  //   ),
  //   loader: breadcrumbLoaderFunction([
  //     ...baseManagerPortalBreadcrumbs,
  //     {label: 'Qualifications'},
  //   ]),
  // },
  {
    path: routes.managerPortal.certificates,
    element: (
      <ProtectedRoute roles={[OPTIX_ACADEMY_MANAGER_READ, CERTIFICATE_READ]}>
        <ManagerPortalCertificates />
      </ProtectedRoute>
    ),
    loader: breadcrumbLoaderFunction([
      ...baseManagerPortalBreadcrumbs,
      {label: 'Certificates'},
    ]),
  },
  {
    path: routes.managerPortal.scheduler,
    element: (
      <ProtectedRoute roles={managerPortalRoles}>
        <ManagerPortalScheduler />
      </ProtectedRoute>
    ),
    loader: breadcrumbLoaderFunction([
      ...baseManagerPortalBreadcrumbs,
      {label: 'Scheduler'},
    ]),
  },
  {
    path: routes.managerPortal.users,
    element: (
      <ProtectedRoute
        conditionalRoles={[
          [OPTIX_ACADEMY_MANAGER_READ, USER_READ],
          [OPTIX_ACADEMY_MANAGER_READ, LEARNERS_READ],
          [OPTIX_ACADEMY_MANAGER_READ, MODERATORS_READ],
          [OPTIX_ACADEMY_MANAGER_READ, FACILITATORS_READ],
          [OPTIX_ACADEMY_MANAGER_READ, ASSESSORS_READ],
        ]}
      >
        <ManagerPortalUsers
          portalRole={OPTIX_ACADEMY_MANAGER_READ}
          readOnly
          userDetailRoute={routes.managerPortal.userDetail}
        />
      </ProtectedRoute>
    ),
    loader: breadcrumbLoaderFunction([
      ...baseManagerPortalBreadcrumbs,
      {label: 'Users'},
    ]),
  },
  {
    path: routes.managerPortal.enrollments,
    element: (
      <ProtectedRoute
        roles={[OPTIX_ACADEMY_MANAGER_READ, LEARNER_ENROLLMENTS_READ]}
      >
        <ManagerPortalEnrollmentManagement readOnly />
      </ProtectedRoute>
    ),
    loader: breadcrumbLoaderFunction([
      ...baseManagerPortalBreadcrumbs,
      {label: 'Enrollments'},
    ]),
  },
  // Temporarily hidden — re-enable when these pages are ready
  // {
  //   path: routes.managerPortal.cohorts,
  //   element: (
  //     <ProtectedRoute roles={managerPortalRoles}>
  //       <ManagerPortalCohortManagement />
  //     </ProtectedRoute>
  //   ),
  //   loader: breadcrumbLoaderFunction([
  //     ...baseManagerPortalBreadcrumbs,
  //     {label: 'Cohorts'},
  //   ]),
  // },
  // {
  //   path: routes.managerPortal.cohortDetail,
  //   element: (
  //     <ProtectedRoute roles={managerPortalRoles}>
  //       <ManagerPortalCohortDetail />
  //     </ProtectedRoute>
  //   ),
  //   loader: breadcrumbLoaderFunction([
  //     ...baseManagerPortalBreadcrumbs,
  //     {label: 'Cohorts', path: routes.managerPortal.cohorts},
  //     {label: 'Cohort Detail'},
  //   ]),
  // },
  // {
  //   path: routes.managerPortal.moduleManagement,
  //   element: (
  //     <ProtectedRoute
  //       roles={[OPTIX_ACADEMY_MANAGER_READ, TRAINME_COURSES_READ]}
  //     >
  //       <ManagerPortalModuleManagement />
  //     </ProtectedRoute>
  //   ),
  //   loader: breadcrumbLoaderFunction([
  //     ...baseManagerPortalBreadcrumbs,
  //     {label: 'Module Management'},
  //   ]),
  // },
  // {
  //   path: routes.managerPortal.courseModules,
  //   element: (
  //     <ProtectedRoute
  //       roles={[OPTIX_ACADEMY_MANAGER_READ, TRAINME_COURSES_READ]}
  //     >
  //       <ManagerPortalCourseModules />
  //     </ProtectedRoute>
  //   ),
  //   loader: breadcrumbLoaderFunction([
  //     ...baseManagerPortalBreadcrumbs,
  //     {label: 'Course Modules'},
  //   ]),
  // },
  {
    path: routes.managerPortal.announcements,
    element: (
      <ProtectedRoute roles={managerPortalRoles}>
        <ManagerPortalBroadcastAnnouncement />
      </ProtectedRoute>
    ),
    loader: breadcrumbLoaderFunction([
      ...baseManagerPortalBreadcrumbs,
      {label: 'Announcements'},
    ]),
  },
  {
    path: routes.managerPortal.userDetail,
    element: (
      <ProtectedRoute
        roles={[...managerPortalRoles, USER_PROFILE_SUMMARY_READ]}
      >
        <ManagerPortalUserDetail />
      </ProtectedRoute>
    ),
    loader: breadcrumbLoaderFunction([
      ...baseManagerPortalBreadcrumbs,
      {label: 'Users', path: routes.managerPortal.users},
      {label: 'User Detail'},
    ]),
  },
];
